export default __webpack_public_path__ + "static/media/plus-circle-white.bdef8be3.svg";